module.exports = __webpack_public_path__ + "static/media/icon-modal-arrow-right-dark.4ff32926.svg";